import React, { useEffect } from 'react';
import TR from './../../Trans';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import TrackListScroller from './../items/TrackListScroller';
import RefreshIcon from '@mui/icons-material/Refresh';
import songbookSessionStore from './../../stores/songbookSession';
import sessionStore from '../../stores/session';
import newTracksStore from './../../stores/newTracks';
import accountStore from '../../stores/account';

function NewTracks(props) {
  const itemsOnPage = 50;
  const sessionToken = props.isSongbook ? songbookSessionStore((state) => state.sessionToken) : sessionStore((state) => state.sessionToken);
  const isSet = newTracksStore((state) => state.isSet);
  const getLatest = newTracksStore((state) => state.getLatest);
  const isWaiting = newTracksStore((state) => state.isWaiting);
  const getLatestMore = newTracksStore((state) => state.getLatestMore);
  const resetLatest = newTracksStore((state) => state.resetLatest);
  const totalCount = newTracksStore((state) => state.totalCount);
  const tracks = newTracksStore((state) => state.tracks);
  const isFinished = newTracksStore((state) => state.isFinished);
  const accountLang = accountStore((state) => state.account?.language);

  useEffect(() => {}, [accountLang]);

  useEffect(() => { 
    if (!tracks) {
      getLatest(sessionToken, itemsOnPage);
    }
    console.log("new tracks rendered")
  }, []);

  const handleScrollDown = () => { 
    getLatestMore(sessionToken, itemsOnPage);
  };

  const handleRefresh = () => { 
    resetLatest();
    setTimeout(() => { 
      getLatest(sessionToken, itemsOnPage);
    }, 500);
  };

  return (
    <div>
      <Grid container spacing={0}>
        <Grid item xs={11}>
          <h3>{TR.cm_new}</h3>
        </Grid>
        <Grid item xs={1}>
          <IconButton className="muvika-button-right" color="white" component="label" onClick={handleRefresh}>
            <RefreshIcon />
          </IconButton>
        </Grid>
      </Grid>
      <TrackListScroller isSongbook={props.isSongbook} id="catalog-tracklist" isNewTracks={true} isFinished={isFinished} isWaiting={isWaiting} tracks={tracks} onScrollDown={handleScrollDown} />
    </div>
  );
}

export default NewTracks;